import React, { useCallback, useEffect, useState } from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { Permission, Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./PermissionForm.form";
import { MODULES, ACTIONS } from "../../../../utils/constants";
import {
  convertModulesEngToEsp,
  convertActionsEngToEsp,
} from "../../../../utils/converts";
import "./PermissionForm.scss";
import { useLanguage } from "../../../../contexts";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const permissionController = new Permission();
const roleController = new Role();

export function PermissionForm(props) {
  const { close, onReload, permission } = props;
  const { accessToken } = useAuth();
  const [listRoles, setListRoles] = useState([]);
  const [listActionPermissions, setListActionPermissions] = useState([]);
  const [listActions, setListActions] = useState([]);

  const { translations } = useLanguage();

  const t = (key) => translations[key.toLowerCase()] || key; // Función para obtener la traducción

  useEffect(() => {
    roleController.getRoles(accessToken, true).then((response) => {
      setListRoles(response);
    });
  }, []);

  const formik = useFormik({
    initialValues: initialValues(permission),
    validationSchema: validationSchema(permission),
    validateOnChange: false,
    onSubmit: async (formValue, { setSubmitting }) => {
      try {
        if (!permission) {
          const response = await permissionController.createPermission(
            accessToken,
            formValue
          );
          if (response.code && response.code === 200) {
            toast.success("Formulario enviado correctamente!");
          } else {
            toast.error("Hubo un error al enviar el formulario.");
          }
        } else {
          await permissionController.updatePermission(
            accessToken,
            permission._id,
            formValue
          );
        }

        // Espera 120 ms antes de cerrar el modal o hacer un reload
        setTimeout(() => {
          onReload();
          close();
        }, 1200);
        // Establecemos que el formulario ya no está enviando
        setSubmitting(false);
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    if (formik.values.module && formik.values.role) {
      permissionController
        .getPermissionsByRoleAndModule(
          accessToken,
          formik.values.role,
          formik.values.module
        )
        .then((response) => {
          let list = response.response.map((i) => {
            return i.action;
          });
          setListActionPermissions(list);
        });
    }
  }, [formik.values.module, formik.values.role]);

  useEffect(() => {
    if (listActionPermissions && listActionPermissions.length > 0) {
      let newList = ACTIONS.filter((i) => !listActionPermissions.includes(i));
      if (formik && formik.values.action) {
        if (!newList.includes(formik.values.action)) {
          formik.setFieldValue("action", null);
        }
        //newList.push(formik.values.action);
      }
      setListActions(newList);
    } else {
      setListActions(ACTIONS);
    }
  }, [listActionPermissions]);

  const actionIcons = {
  view: { name: "eye", color: "black" },
  delete: { name: "trash", color: "black" },
  edit: { name: "pencil alternate", color: "black" },
    create: { name: "add circle", color: "black" },
      menu: { name: "th list", color: "black" }
};

  return (
    <Form className="permission-form" onSubmit={formik.handleSubmit}>
      <Form.Group widths="equal">
        <Form.Dropdown
            label={
    <>
      <span style={{ fontWeight: "bold" }}>{t("role")}</span>{" "}
      <span style={{ color: "red" }}>*</span>
    </>
  }
          //placeholder="Selecciona un rol"
          options={listRoles.map((ds) => {
            return {
              key: ds._id,
              text: t(ds.name),
              value: ds._id,
            };
          })}
          selection
          onChange={(_, data) => formik.setFieldValue("role", data.value)}
          value={formik.values.role}
          error={formik.errors.role}
        />
      </Form.Group>
      <Form.Group widths="equal">
        <Form.Dropdown
            label={
    <>
      <span style={{ fontWeight: "bold" }}>{t("module")}</span>{" "}
      <span style={{ color: "red" }}>*</span>
    </>
  }
          //placeholder="Selecciona un módulo"
          options={MODULES.map((ds) => {
            return {
              key: ds,
              text: t(ds),
              value: ds,
            };
          })}
          selection
          scrolling 
          onChange={(_, data) => formik.setFieldValue("module", data.value)}
          value={formik.values.module}
          error={formik.errors.module}
        />
        <Form.Dropdown
            label={
    <>
      <span style={{ fontWeight: "bold" }}>{t("action")}</span>{" "}
      <span style={{ color: "red" }}>*</span>
    </>
  }
          placeholder={
            listActions && listActions.length > 0
              ? "Selecciona una acción"
              : " No hay acciones para elegir"
          }
          options={listActions.map((ds) => {
            return {
              key: ds,
              text: t(ds),
              value: ds,
              icon: actionIcons[ds.toLowerCase()] || { name: "question" }, // asigna icono según acción
            };
          })}
          selection
          onChange={(_, data) => formik.setFieldValue("action", data.value)}
          value={formik.values.action}
          error={formik.errors.action}
        />
      </Form.Group>
      <Form.TextArea
        label={<span style={{ fontWeight: "bold" }}>{t("description")}</span>}
        style={{ minHeight: 100 }}
        name="description"
        onChange={formik.handleChange}
        value={formik.values.description}
        error={formik.errors.description}
      />

   <div
           style={{
             display: "flex",
             justifyContent: "center",
             gap: "1rem",
             marginTop: 36,
           }}
         >
           <Form.Button
             type="submit"
             primary
             size="large"
             loading={formik.isSubmitting}
             content={!permission ? t("save") : t("update")}
           ></Form.Button>

           <Form.Button
             type="button"
             color="red"
             secondary
             size="large"
             onClick={() => {
               close()
             }}
           >
             {t("cancel")}
           </Form.Button>
         </div>

      {/* Este componente mostrará las notificaciones */}
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Form>
  );
}
